import {
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React, { useEffect, useState } from "react";
import { Button, ShowProps, useDataProvider } from "react-admin";
import { GridinRow, GridinRowsWithSpace, GridLabel } from "utils/style";
import { GetParam } from "utils/tools";
import IconPlus from "@material-ui/icons/Add";
import DeletePermission from "pages/studentPermissions/components/DeletePermission";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    padding: "1rem",
  },
  summaryButton: {
    position: "relative",
    top: 20,
    padding: "8px 16px",
  },
});

const Permission = (props: ShowProps) => {
  const [permissions, setPermissions] = useState<IStudentPermission[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const provider = useDataProvider();
  const classes = useStyles();
  const param = GetParam();
  const { id } = props;

  const getStudentPermissions = () => {
    setLoading(true);
    provider
      .customGetListWithStaticParams(
        `students/${id}/permissions?Query.Filter=${JSON.stringify({
          IsMain: false,
        })}`
      )
      .then(({ data }: any) => {
        setPermissions(data as IStudentPermission[]);
        setLoading(false);
      });
  };

  useEffect(() => {
    getStudentPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SanitizedGrid container spacing={2}>
      <Grid item xs={12} style={GridinRowsWithSpace}>
        <Typography variant="h6">Permissions</Typography>

        <Button
          onClick={() =>
            props.history.push(
              `/studentPermissions/create?source=${JSON.stringify({
                studentId: Number(id),
              })}&studentId=${Number(id)}${
                param.get("parentId")
                  ? `&parentId=${param.get("parentId")}`
                  : ""
              }`
            )
          }
          label="Add New Permission"
        >
          <IconPlus />
        </Button>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Parent</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {permissions.length > 0 ? (
                <>
                  {permissions.map(
                    (permission: IStudentPermission, key: number) => {
                      return (
                        <TableRow key={`permission-${key}`}>
                          <TableCell>
                            <SanitizedGrid container spacing={2}>
                              <Grid item xs={12} style={GridinRow}>
                                <Typography variant="body2" style={GridLabel}>
                                  Id : {permission.parent.id}
                                </Typography>
                              </Grid>

                              <Grid item xs={12} style={GridinRow}>
                                <Typography variant="body2" style={GridLabel}>
                                  Name : {permission.parent.firstName}{" "}
                                  {permission.parent.lastName}
                                </Typography>
                              </Grid>

                              <Grid item xs={12} style={GridinRow}>
                                <Typography variant="body2" style={GridLabel}>
                                  Email : {permission.parent.email}
                                </Typography>
                              </Grid>
                            </SanitizedGrid>
                          </TableCell>
                          <TableCell>
                            <DeletePermission
                              permissionId={permission.id}
                              studentId={Number(id)}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
                </>
              ) : (
                <TableRow>
                  <TableCell colSpan={4}>
                    {loading ? "Loading..." : "No results found."}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </SanitizedGrid>
  );
};

export default Permission;
